import useBrandbookConfigValues from './useBrandbookConfigValues'

export default useBrandbookConfigValues
